import React from 'react';
import { Combo } from 'fw/forms';
import * as API from 'modules/app/API'

class CertificationTypeExtendedCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    completed = () => { return this._ctrl.completed(); }
    flag = () => { return this._ctrl.flag(); }

    loadItems = () => {
        let items = [];

        items.push({ label: "Certification", value: "CER"});
        items.push({ label: "First Renewal", value: "REN1"});
        items.push({ label: "Second Renewal", value: "REN2"});
        items.push({ label: "Re-Certification", value: "REC"});

        this.setState({items});
    }

    componentDidMount = () => {
        this._isMounted = true;

        let rq = {
            CertificationId: this.props.certificationId
        }

        API.Admin.get('/certification/getCertificationTypes', rq,
            {
                success: (r) => {
                    this._isMounted && this.setState({
                        items: r.data.items.map((item) => { return { label: item.certificationTypeDescription, value: item.certificationTypeCode } })
                    });
                }
            }, { block: false });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }
    render() {
        return (
            <Combo
                {...this.props}
                placeholder={this.props.placeholder ? this.props.placeholder : "Select Certification Type ..."}
                items={this.state.items}
                searchable={true}
                ref={(c) => { this._ctrl = c }} />
        )
    }
}

export default CertificationTypeExtendedCombo;

// Mark this as a form component
CertificationTypeExtendedCombo.defaultProps = {
    formControl: true,
    managed: false
};


// WEBPACK FOOTER //
// ./src/areas/shared/controls/certificationTypeExtendedCombo/CertificationTypeExtendedCombo.js